export const mutations = {
  setListFeatureFlags(state, payload) {
    state.listFeatureFlags = payload;
  },
};
